import { InfoElement } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getDifferenceWithPrecision } from 'utils'

function Percent({ revenuePercent }) {
  const { t: translate } = useTranslation()

  return (
    <InfoElement
      percentDifference={getDifferenceWithPrecision({
        handleNullCase: true,
        number: revenuePercent,
        precision: 0,
        translate,
      })}
    />
  )
}

export default Percent
